export default [
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "Edward Hospital",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -88.153422,
    "latitude": 41.760658,
    "line_1": "801 SOUTH WASHINGTON STREET",
    "line_2": "",
    "city": "NAPERVILLE",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "60540",
    "gemRanking": 2,
    "googlePlaceId": "ChIJ8RzFT-tXDogRcmXf4bJ5Vfs",
    "distance": 8.526,
    "timeInTraffic": "16 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(630) 527-3000",
    "fax": null,
    "email": null,
    "partyId": 191245,
    "locationId": 9659548,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "801",
            "short_name": "801",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "South Washington Street",
            "short_name": "S Washington St",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Naperville Park District",
            "short_name": "Naperville Park District",
            "types": [
              "neighborhood",
              "political"
            ]
          },
          {
            "long_name": "Naperville",
            "short_name": "Naperville",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "Naperville Township",
            "short_name": "Naperville Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "DuPage County",
            "short_name": "Dupage County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60540",
            "short_name": "60540",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "801 S Washington St, Naperville, IL 60540, USA",
        "formatted_phone_number": "(630) 527-3000",
        "geometry": {
          "location": {
            "lat": 41.7606589,
            "lng": -88.1534222
          },
          "viewport": {
            "northeast": {
              "lat": 41.76244303029149,
              "lng": -88.14922145
            },
            "southwest": {
              "lat": 41.7597450697085,
              "lng": -88.15482244999998
            }
          }
        },
        "international_phone_number": "+1 630-527-3000",
        "name": "Edward Hospital - Main Campus",
        "opening_hours": null,
        "permanently_closed": false,
        "place_id": "ChIJ8RzFT-tXDogRcmXf4bJ5Vfs",
        "website": "https://www.eehealth.org/locations/naperville/edward-hospital-main-campus?utm_campaign=website-link&utm_medium=organic&utm_source=local-listing"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": false,
    "isOpen": false,
    "isOpenBit": 0,
    "hasHours": false,
    "todaysHours": "Unknown"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "Advocate Good Samaritan Hospital",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -88.008362,
    "latitude": 41.818356,
    "line_1": "3815 HIGHLAND AVENUE",
    "line_2": "",
    "city": "DOWNERS GROVE",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "605151500",
    "gemRanking": 1,
    "googlePlaceId": "ChIJH0a4ZQFODogRxuiuOHTiJ1M",
    "distance": 11.906,
    "timeInTraffic": "15 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(630) 275-5900",
    "fax": null,
    "email": null,
    "partyId": 202453,
    "locationId": 9659563,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "Sunday: Open 24 hours",
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours"
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "3815",
            "short_name": "3815",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "Highland Avenue",
            "short_name": "Highland Ave",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Downers Grove",
            "short_name": "Downers Grove",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "York Township",
            "short_name": "York Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "DuPage County",
            "short_name": "Dupage County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60515",
            "short_name": "60515",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "3815 Highland Ave, Downers Grove, IL 60515, USA",
        "formatted_phone_number": "(630) 275-5900",
        "geometry": {
          "location": {
            "lat": 41.8176708,
            "lng": -88.0082896
          },
          "viewport": {
            "northeast": {
              "lat": 41.8192425302915,
              "lng": -88.0070495697085
            },
            "southwest": {
              "lat": 41.8165445697085,
              "lng": -88.0097475302915
            }
          }
        },
        "international_phone_number": "+1 630-275-5900",
        "name": "Advocate Good Samaritan Hospital",
        "opening_hours": {
          "open_now": true,
          "periods": [
            {
              "close": null,
              "open": {
                "day": 0,
                "time": "0000"
              }
            }
          ],
          "weekday_text": [
            "Monday: Open 24 hours",
            "Tuesday: Open 24 hours",
            "Wednesday: Open 24 hours",
            "Thursday: Open 24 hours",
            "Friday: Open 24 hours",
            "Saturday: Open 24 hours",
            "Sunday: Open 24 hours"
          ]
        },
        "permanently_closed": false,
        "place_id": "ChIJH0a4ZQFODogRxuiuOHTiJ1M",
        "website": "http://advocatehealth.com/gsam/"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": true,
    "isOpen": true,
    "isOpenBit": 1,
    "hasHours": true,
    "todaysHours": "Friday: Open 24 hours"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "Northwestern Medicine Central DuPage Hospital",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -88.155669,
    "latitude": 41.873562,
    "line_1": "25 WINFIELD ROAD",
    "line_2": "NORTHWESTERN MEDICINE CENTRAL DUPAGE HOSPITAL",
    "city": "WINFIELD",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "601901237",
    "gemRanking": 3,
    "googlePlaceId": "ChIJ1VnKt3FVDogRsM1YxoDTrQA",
    "distance": 15.684,
    "timeInTraffic": "23 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(630) 933-1600",
    "fax": null,
    "email": null,
    "partyId": 30382,
    "locationId": 9659553,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "Sunday: Open 24 hours",
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours"
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "25 N",
            "short_name": "25 N",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "Winfield Road",
            "short_name": "Winfield Rd",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Winfield",
            "short_name": "Winfield",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "Winfield Township",
            "short_name": "Winfield Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "DuPage County",
            "short_name": "Dupage County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60190",
            "short_name": "60190",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "25 N Winfield Rd, Winfield, IL 60190, USA",
        "formatted_phone_number": "(630) 933-1600",
        "geometry": {
          "location": {
            "lat": 41.8734039,
            "lng": -88.15551529999999
          },
          "viewport": {
            "northeast": {
              "lat": 41.8746300802915,
              "lng": -88.15462645
            },
            "southwest": {
              "lat": 41.8719321197085,
              "lng": -88.15818185
            }
          }
        },
        "international_phone_number": "+1 630-933-1600",
        "name": "Northwestern Medicine Central DuPage Hospital",
        "opening_hours": {
          "open_now": true,
          "periods": [
            {
              "close": null,
              "open": {
                "day": 0,
                "time": "0000"
              }
            }
          ],
          "weekday_text": [
            "Monday: Open 24 hours",
            "Tuesday: Open 24 hours",
            "Wednesday: Open 24 hours",
            "Thursday: Open 24 hours",
            "Friday: Open 24 hours",
            "Saturday: Open 24 hours",
            "Sunday: Open 24 hours"
          ]
        },
        "permanently_closed": false,
        "place_id": "ChIJ1VnKt3FVDogRsM1YxoDTrQA",
        "website": "https://www.nm.org/locations/central-dupage-hospital?utm_source=yext&utm_medium=gmb%20location&utm_campaign=online%20listings"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": true,
    "isOpen": true,
    "isOpenBit": 1,
    "hasHours": true,
    "todaysHours": "Friday: Open 24 hours"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "Rush-Copley Medical Center",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -88.270837,
    "latitude": 41.728611,
    "line_1": "2000 OGDEN AVENUE",
    "line_2": "",
    "city": "AURORA",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "60504",
    "gemRanking": 4,
    "googlePlaceId": "ChIJt3rXpZTwDogRL61GhDsun7U",
    "distance": 18.769,
    "timeInTraffic": "29 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(630) 978-6200",
    "fax": null,
    "email": null,
    "partyId": 346442,
    "locationId": 9659454,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "Sunday: Open 24 hours",
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours"
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "2000",
            "short_name": "2000",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "Ogden Avenue",
            "short_name": "Ogden Ave",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Aurora",
            "short_name": "Aurora",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "Aurora Township",
            "short_name": "Aurora Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "Kane County",
            "short_name": "Kane County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60504",
            "short_name": "60504",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "2000 Ogden Ave, Aurora, IL 60504, USA",
        "formatted_phone_number": "(630) 978-6200",
        "geometry": {
          "location": {
            "lat": 41.7291519,
            "lng": -88.2704493
          },
          "viewport": {
            "northeast": {
              "lat": 41.7304668302915,
              "lng": -88.26872016970849
            },
            "southwest": {
              "lat": 41.72776886970851,
              "lng": -88.2714181302915
            }
          }
        },
        "international_phone_number": "+1 630-978-6200",
        "name": "Rush Copley Medical Center",
        "opening_hours": {
          "open_now": true,
          "periods": [
            {
              "close": null,
              "open": {
                "day": 0,
                "time": "0000"
              }
            }
          ],
          "weekday_text": [
            "Monday: Open 24 hours",
            "Tuesday: Open 24 hours",
            "Wednesday: Open 24 hours",
            "Thursday: Open 24 hours",
            "Friday: Open 24 hours",
            "Saturday: Open 24 hours",
            "Sunday: Open 24 hours"
          ]
        },
        "permanently_closed": false,
        "place_id": "ChIJt3rXpZTwDogRL61GhDsun7U",
        "website": "https://www.rushcopley.com/"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": true,
    "isOpen": true,
    "isOpenBit": 1,
    "hasHours": true,
    "todaysHours": "Friday: Open 24 hours"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "Elmhurst Hospital",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -87.935867,
    "latitude": 41.864019,
    "line_1": "155 EAST BRUSH HILL ROAD",
    "line_2": "",
    "city": "ELMHURST",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "601265658",
    "gemRanking": 3,
    "googlePlaceId": "ChIJV1d7RlZNDogRQwYRWz5qIbc",
    "distance": 20.187,
    "timeInTraffic": "20 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(331) 221-1000",
    "fax": null,
    "email": null,
    "partyId": 371465,
    "locationId": 9659536,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "Sunday: Open 24 hours",
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours"
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "155",
            "short_name": "155",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "East Brush Hill Road",
            "short_name": "E Brush Hill Rd",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Elmhurst",
            "short_name": "Elmhurst",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "York Township",
            "short_name": "York Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "DuPage County",
            "short_name": "Dupage County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60126",
            "short_name": "60126",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "155 E Brush Hill Rd, Elmhurst, IL 60126, USA",
        "formatted_phone_number": "(331) 221-1000",
        "geometry": {
          "location": {
            "lat": 41.8640197,
            "lng": -87.9358675
          },
          "viewport": {
            "northeast": {
              "lat": 41.86556883029149,
              "lng": -87.9345160697085
            },
            "southwest": {
              "lat": 41.86287086970849,
              "lng": -87.9372140302915
            }
          }
        },
        "international_phone_number": "+1 331-221-1000",
        "name": "Elmhurst Hospital - Main Campus",
        "opening_hours": {
          "open_now": true,
          "periods": [
            {
              "close": null,
              "open": {
                "day": 0,
                "time": "0000"
              }
            }
          ],
          "weekday_text": [
            "Monday: Open 24 hours",
            "Tuesday: Open 24 hours",
            "Wednesday: Open 24 hours",
            "Thursday: Open 24 hours",
            "Friday: Open 24 hours",
            "Saturday: Open 24 hours",
            "Sunday: Open 24 hours"
          ]
        },
        "permanently_closed": false,
        "place_id": "ChIJV1d7RlZNDogRQwYRWz5qIbc",
        "website": "https://www.eehealth.org/locations/elmhurst/elmhurst-hospital-main-campus?utm_source=local&utm_medium=organic&utm_campaign=gmb"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": true,
    "isOpen": true,
    "isOpenBit": 1,
    "hasHours": true,
    "todaysHours": "Friday: Open 24 hours"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "AMITA Health Adventist Medical Center  Bolingbrook",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -88.084732,
    "latitude": 41.680796,
    "line_1": "500 REMINGTON BOULEVARD",
    "line_2": "",
    "city": "BOLINGBROOK",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "60440",
    "gemRanking": 3,
    "googlePlaceId": "ChIJq4C5PFxZDogRi1k0pqi3KDs",
    "distance": 21.289,
    "timeInTraffic": "21 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(630) 312-5000",
    "fax": null,
    "email": null,
    "partyId": 211919,
    "locationId": 9659570,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "Sunday: Open 24 hours",
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours"
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "500",
            "short_name": "500",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "Remington Boulevard",
            "short_name": "Remington Blvd",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Bolingbrook",
            "short_name": "Bolingbrook",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "Du Page Township",
            "short_name": "Du Page Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "Will County",
            "short_name": "Will County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60440",
            "short_name": "60440",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "500 Remington Blvd, Bolingbrook, IL 60440, USA",
        "formatted_phone_number": "(630) 312-5000",
        "geometry": {
          "location": {
            "lat": 41.6807968,
            "lng": -88.08473289999999
          },
          "viewport": {
            "northeast": {
              "lat": 41.6824308302915,
              "lng": -88.08168250000001
            },
            "southwest": {
              "lat": 41.6797328697085,
              "lng": -88.08574969999998
            }
          }
        },
        "international_phone_number": "+1 630-312-5000",
        "name": "AMITA Health Adventist Medical Center Bolingbrook",
        "opening_hours": {
          "open_now": true,
          "periods": [
            {
              "close": null,
              "open": {
                "day": 0,
                "time": "0000"
              }
            }
          ],
          "weekday_text": [
            "Monday: Open 24 hours",
            "Tuesday: Open 24 hours",
            "Wednesday: Open 24 hours",
            "Thursday: Open 24 hours",
            "Friday: Open 24 hours",
            "Saturday: Open 24 hours",
            "Sunday: Open 24 hours"
          ]
        },
        "permanently_closed": false,
        "place_id": "ChIJq4C5PFxZDogRi1k0pqi3KDs",
        "website": "https://www.amitahealth.org/locations/hospitals/bolingbrook"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": true,
    "isOpen": true,
    "isOpenBit": 1,
    "hasHours": true,
    "todaysHours": "Friday: Open 24 hours"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "AMITA Health Adventist GlenOaks Hospital",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -88.057013,
    "latitude": 41.915281,
    "line_1": "701 WINTHROP AVENUE",
    "line_2": "",
    "city": "GLENDALE HEIGHTS",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "601391405",
    "gemRanking": 3,
    "googlePlaceId": "ChIJ47XhQNqsD4gRsCxDM8Oo9Gw",
    "distance": 21.974,
    "timeInTraffic": "22 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(630) 545-8000",
    "fax": null,
    "email": null,
    "partyId": 147049,
    "locationId": 9659567,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "Sunday: Open 24 hours",
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours"
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "701 N",
            "short_name": "701 N",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "Winthrop Avenue",
            "short_name": "Winthrop Ave",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Glendale Heights",
            "short_name": "Glendale Heights",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "Bloomingdale Township",
            "short_name": "Bloomingdale Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "DuPage County",
            "short_name": "Dupage County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60139",
            "short_name": "60139",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "701 N Winthrop Ave, Glendale Heights, IL 60139, USA",
        "formatted_phone_number": "(630) 545-8000",
        "geometry": {
          "location": {
            "lat": 41.9152811,
            "lng": -88.0570138
          },
          "viewport": {
            "northeast": {
              "lat": 41.9165830802915,
              "lng": -88.0559458197085
            },
            "southwest": {
              "lat": 41.9138851197085,
              "lng": -88.0586437802915
            }
          }
        },
        "international_phone_number": "+1 630-545-8000",
        "name": "AMITA Health Adventist Medical Center GlenOaks",
        "opening_hours": {
          "open_now": true,
          "periods": [
            {
              "close": null,
              "open": {
                "day": 0,
                "time": "0000"
              }
            }
          ],
          "weekday_text": [
            "Monday: Open 24 hours",
            "Tuesday: Open 24 hours",
            "Wednesday: Open 24 hours",
            "Thursday: Open 24 hours",
            "Friday: Open 24 hours",
            "Saturday: Open 24 hours",
            "Sunday: Open 24 hours"
          ]
        },
        "permanently_closed": false,
        "place_id": "ChIJ47XhQNqsD4gRsCxDM8Oo9Gw",
        "website": "https://www.amitahealth.org/locations/hospitals/glenoaks"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": true,
    "isOpen": true,
    "isOpenBit": 1,
    "hasHours": true,
    "todaysHours": "Friday: Open 24 hours"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "AMITA Health Adventist Medical Center Hinsdale",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -87.920693,
    "latitude": 41.805609,
    "line_1": "120 NORTH OAK STREET",
    "line_2": "",
    "city": "HINSDALE",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "605213829",
    "gemRanking": 3,
    "googlePlaceId": "ChIJezjxkkZJDogReH-5CJ1Hshg",
    "distance": 23.549,
    "timeInTraffic": "22 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(630) 856-9000",
    "fax": null,
    "email": null,
    "partyId": 147071,
    "locationId": 9659499,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "",
      "",
      "",
      "",
      "",
      "",
      ""
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "120",
            "short_name": "120",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "North Oak Street",
            "short_name": "N Oak St",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Hinsdale",
            "short_name": "Hinsdale",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "Downers Grove Township",
            "short_name": "Downers Grove Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "DuPage County",
            "short_name": "Dupage County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60521",
            "short_name": "60521",
            "types": [
              "postal_code"
            ]
          },
          {
            "long_name": "3829",
            "short_name": "3829",
            "types": [
              "postal_code_suffix"
            ]
          }
        ],
        "formatted_address": "120 N Oak St, Hinsdale, IL 60521, USA",
        "formatted_phone_number": "(630) 856-9000",
        "geometry": {
          "location": {
            "lat": 41.8060175,
            "lng": -87.9207065
          },
          "viewport": {
            "northeast": {
              "lat": 41.8073224802915,
              "lng": -87.9193348197085
            },
            "southwest": {
              "lat": 41.8046245197085,
              "lng": -87.9220327802915
            }
          }
        },
        "international_phone_number": "+1 630-856-9000",
        "name": "AMITA Health Adventist Medical Center Hinsdale",
        "opening_hours": null,
        "permanently_closed": false,
        "place_id": "ChIJezjxkkZJDogReH-5CJ1Hshg",
        "website": "https://www.amitahealth.org/locations/hospitals/hinsdale"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": false,
    "isOpen": false,
    "isOpenBit": 0,
    "hasHours": false,
    "todaysHours": "Unknown"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "Presence Mercy Medical Center",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -88.32564,
    "latitude": 41.78595,
    "line_1": "1325 North Highland Avenue",
    "line_2": "",
    "city": "Aurora",
    "province": "Illinois",
    "country": "United States",
    "zip": "60506",
    "gemRanking": 4,
    "googlePlaceId": "ChIJ0QvZF9X6DogRtyZUywrWFCo",
    "distance": 23.878,
    "timeInTraffic": "22 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(630) 859-2222",
    "fax": null,
    "email": null,
    "partyId": 172694,
    "locationId": 9659522,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "Sunday: Open 24 hours",
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours"
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "1325",
            "short_name": "1325",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "North Highland Avenue",
            "short_name": "N Highland Ave",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "Aurora",
            "short_name": "Aurora",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "Aurora Township",
            "short_name": "Aurora Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "Kane County",
            "short_name": "Kane County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60506",
            "short_name": "60506",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "1325 N Highland Ave, Aurora, IL 60506, USA",
        "formatted_phone_number": "(630) 859-2222",
        "geometry": {
          "location": {
            "lat": 41.786071,
            "lng": -88.325724
          },
          "viewport": {
            "northeast": {
              "lat": 41.7875883802915,
              "lng": -88.3239533197085
            },
            "southwest": {
              "lat": 41.7848904197085,
              "lng": -88.3266512802915
            }
          }
        },
        "international_phone_number": "+1 630-859-2222",
        "name": "Presence Mercy Medical Center",
        "opening_hours": {
          "open_now": true,
          "periods": [
            {
              "close": null,
              "open": {
                "day": 0,
                "time": "0000"
              }
            }
          ],
          "weekday_text": [
            "Monday: Open 24 hours",
            "Tuesday: Open 24 hours",
            "Wednesday: Open 24 hours",
            "Thursday: Open 24 hours",
            "Friday: Open 24 hours",
            "Saturday: Open 24 hours",
            "Sunday: Open 24 hours"
          ]
        },
        "permanently_closed": false,
        "place_id": "ChIJ0QvZF9X6DogRtyZUywrWFCo",
        "website": "http://www.presencehealth.org/presence-mercy-medical-center-aurora"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": true,
    "isOpen": true,
    "isOpenBit": 1,
    "hasHours": true,
    "todaysHours": "Friday: Open 24 hours"
  },
  {
    "isGoogle": false,
    "hthId": 0,
    "network": null,
    "isGEM": true,
    "name": "AMITA Health Adventist Medical Center La Grange",
    "originalName": null,
    "translated": false,
    "type": "Organization",
    "gender": "",
    "service": "Emergency Room",
    "longitude": -87.886388,
    "latitude": 41.796745,
    "line_1": "5101 WILLOW SPRINGS ROAD",
    "line_2": "",
    "city": "LA GRANGE",
    "province": "ILLINOIS",
    "country": "UNITED STATES",
    "zip": "605252600",
    "gemRanking": 2,
    "googlePlaceId": "ChIJnbDGzqNJDogRIpxkHAPQ_MQ",
    "distance": 26.937,
    "timeInTraffic": "26 mins",
    "isPediatric": 0,
    "distanceUnit": "km",
    "phone": "(708) 245-9000",
    "fax": null,
    "email": null,
    "partyId": 148193,
    "locationId": 9659473,
    "isNetworkProvider": false,
    "providerIdType": null,
    "providerId": null,
    "hoursPerDay": [
      "Sunday: Open 24 hours",
      "Monday: Open 24 hours",
      "Tuesday: Open 24 hours",
      "Wednesday: Open 24 hours",
      "Thursday: Open 24 hours",
      "Friday: Open 24 hours",
      "Saturday: Open 24 hours"
    ],
    "placeResult": {
      "result": {
        "address_components": [
          {
            "long_name": "5101",
            "short_name": "5101",
            "types": [
              "street_number"
            ]
          },
          {
            "long_name": "Willow Springs Road",
            "short_name": "Willow Springs Rd",
            "types": [
              "route"
            ]
          },
          {
            "long_name": "La Grange",
            "short_name": "La Grange",
            "types": [
              "locality",
              "political"
            ]
          },
          {
            "long_name": "Lyons Township",
            "short_name": "Lyons Township",
            "types": [
              "administrative_area_level_3",
              "political"
            ]
          },
          {
            "long_name": "Cook County",
            "short_name": "Cook County",
            "types": [
              "administrative_area_level_2",
              "political"
            ]
          },
          {
            "long_name": "Illinois",
            "short_name": "IL",
            "types": [
              "administrative_area_level_1",
              "political"
            ]
          },
          {
            "long_name": "United States",
            "short_name": "US",
            "types": [
              "country",
              "political"
            ]
          },
          {
            "long_name": "60525",
            "short_name": "60525",
            "types": [
              "postal_code"
            ]
          }
        ],
        "formatted_address": "5101 Willow Springs Rd, La Grange, IL 60525, USA",
        "formatted_phone_number": "(708) 245-9000",
        "geometry": {
          "location": {
            "lat": 41.7967451,
            "lng": -87.8863882
          },
          "viewport": {
            "northeast": {
              "lat": 41.7984292302915,
              "lng": -87.8850566197085
            },
            "southwest": {
              "lat": 41.7957312697085,
              "lng": -87.8877545802915
            }
          }
        },
        "international_phone_number": "+1 708-245-9000",
        "name": "AMITA Health Adventist Medical Center La Grange",
        "opening_hours": {
          "open_now": true,
          "periods": [
            {
              "close": null,
              "open": {
                "day": 0,
                "time": "0000"
              }
            }
          ],
          "weekday_text": [
            "Monday: Open 24 hours",
            "Tuesday: Open 24 hours",
            "Wednesday: Open 24 hours",
            "Thursday: Open 24 hours",
            "Friday: Open 24 hours",
            "Saturday: Open 24 hours",
            "Sunday: Open 24 hours"
          ]
        },
        "permanently_closed": false,
        "place_id": "ChIJnbDGzqNJDogRIpxkHAPQ_MQ",
        "website": "https://www.amitahealth.org/locations/hospitals/lagrange"
      }
    },
    "hour": null,
    "permanentlyClosed": false,
    "financeEmail": null,
    "isAlwaysOpen": true,
    "isOpen": true,
    "isOpenBit": 1,
    "hasHours": true,
    "todaysHours": "Friday: Open 24 hours"
  }
]
